import { Card, Skeleton, Divider } from "antd";

const InfoSkeleton = () => {
  return (
    <div className="space-y-1">
      <Skeleton.Input active size="small" style={{ width: 120 }} />
      <Skeleton.Input active size="small" block style={{ width: "80%" }} />
    </div>
  );
};

export const SkeletonViewPetProfile = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* HEADER */}
      <div className="flex gap-4 items-start">
        <Skeleton.Button active size="large" />

        <div className="space-y-2">
          <Skeleton.Input active size="large" style={{ width: 180 }} />
        </div>
      </div>

      {/* IMAGE */}
      <Skeleton.Image
        active
        style={{ width: "100%", height: 420, borderRadius: 16 }}
      />

      {/* THUMBNAILS */}
      <div className="flex gap-3 flex-wrap">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton.Image
            key={i}
            active
            style={{ width: 96, height: 96, borderRadius: 12 }}
          />
        ))}
      </div>

      {/* BASIC INFO */}
      <Card>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {Array.from({ length: 6 }).map((_, i) => (
            <InfoSkeleton key={i} />
          ))}
        </div>
      </Card>

      {/* HEALTH */}
      <Card>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {Array.from({ length: 5 }).map((_, i) => (
            <InfoSkeleton key={i} />
          ))}
        </div>

        <Divider />

        <Skeleton active paragraph={{ rows: 2 }} />
      </Card>

      {/* ROUTINE */}
      <Card>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {Array.from({ length: 4 }).map((_, i) => (
            <InfoSkeleton key={i} />
          ))}
        </div>
      </Card>

      {/* BEHAVIOR */}
      <Card>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {Array.from({ length: 4 }).map((_, i) => (
            <InfoSkeleton key={i} />
          ))}
        </div>

        <Divider />

        <Skeleton active paragraph={{ rows: 2 }} />
      </Card>
    </div>
  );
};
